import { EmptyStateIcon } from '../../../../../assets/icons';

interface Props {
    /** Owned by the caller so each screen keeps its own spacing/typography. */
    className?: string;
    text?: string;
};

function EmptyState({ className, text = 'No data.' }: Props) {
    return (
        <div className={className}>
            <EmptyStateIcon />
            <span>{text}</span>
        </div>
    );
};

export default EmptyState;
